// extracted by mini-css-extract-plugin
export default {"bottomBarContainer":"bottomBar_bottomBarContainer__DaWqL","bottomBarWidth":"bottomBar_bottomBarWidth__b3uGq"};